export default __webpack_public_path__ + "static/media/01-BM.632f6d92.gif";